/**
 * @class issueConstants
 */
import { tableConstantsFactory } from './tableConstantsFactory';
const issueConstants = tableConstantsFactory('ISSUE');
issueConstants.ISSUEITEMGROUP_INDEX_SUCCESS = 'ISSUE_ISSUEITEMGROUP_INDEX_SUCCESS';
issueConstants.ISSUENDTGROUP_INDEX_SUCCESS = 'ISSUE_ISSUENDTGROUP_INDEX_SUCCESS';
issueConstants.REPORT_SHOW_SUCCESS = 'ISSUE_REPORT_SHOW_SUCCESS';
issueConstants.SIBLING_CLEAR = 'ISSUE_SIBLING_CLEAR';
issueConstants.SIBLING_SHOW = 'ISSUE_SIBLING_SHOW';
issueConstants.ISSUE_ANNOTATION_RENDER_SUCCESS = 'ISSUE_ANNOTATION_RENDER_SUCCESS';
issueConstants.ISSUE_ANNOTATION_RENDER_FAILURE = 'ISSUE_ANNOTATION_RENDER_FAILURE';
issueConstants.INDEX_BY_REPORT = 'ISSUE_INDEX_BY_REPORT';
issueConstants.FORMAT_CHANGE = 'FORMAT_CHANGE';
export default issueConstants;